import styled from '@emotion/styled';
import { SilkIcon } from 'src/domains/sportsbook/assets/icons/SilkIcon';
import { withConfig } from 'src/withConfig';

export const SilkIconWrapperNew = withConfig(theme => styled(SilkIcon, { label: 'SilkIconWrapperNew' })`
    fill: ${theme.star.racingNextOff.raceBox.bgColor};
    width: 40px;
`);
